import {useState} from "react";
import * as React from "react";
import {Button, TextField} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {requestPasswordReset} from "../../utils/Api";
import FormWrapper from "../../components/PaperFormWrapper/PaperFormWrapper";

export const ForgotPasswordContainer = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleEmailInput = (event) => {
        setEmail(event.target.value)
    };

    const handleReset = async (event) => {
        event.preventDefault();
        setLoading(true)
        requestPasswordReset({
            "email": email.toLowerCase()
        });
        navigate('/login/reset-password');
    };

    return (
        <FormWrapper title="Forgot Password" titleLinkTo={"/login"} titleLinkLabel="Back to Login" loading={loading}
                     onSubmit={handleReset}>
            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                onChange={handleEmailInput}
            />
            <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{mt: 3}}
                disabled={loading || email === ''}
            >
                Send Password Reset Email
            </Button>
        </FormWrapper>

    );
};

